import { render, staticRenderFns } from "./EditUserRole.vue?vue&type=template&id=38803a7a&scoped=true&"
import script from "./EditUserRole.vue?vue&type=script&lang=js&"
export * from "./EditUserRole.vue?vue&type=script&lang=js&"
import style0 from "./EditUserRole.vue?vue&type=style&index=0&id=38803a7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38803a7a",
  null
  
)

export default component.exports